import { ArrayUtils, engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { HtmlContainerElement } from "../HTMLComponents/Elements/HtmlContainerElement";
import { Configuration } from "../Components/Configuration";
import { DataManager } from "../Managers/DataManager";
import { AppContext } from "../../Common/AppContext";
import { HtmlButtonElement } from "../HTMLComponents/Elements/HtmlButtonElement";
import { HtmlController } from "../HTMLComponents/HtmlController";
import { UserAction } from "../HTMLComponents/UserAction";
import { SchemasManager } from "../Managers/SchemasManager";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlTableColorsElement extends HtmlContainerElement {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    //******************************************************************************************************************
    //  CREATE
    //******************************************************************************************************************

    create(node: Element): void {
        super.create(node);

        const colors = this.getColors();
        this.createTableColors(colors);
        this.createColorBtns(colors);
    }

    //******************************************************************************************************************
    //  COLOR BTNS
    //******************************************************************************************************************

    private getColors(): Array<string> {
        let colors = AppContext.gameConfiguration.TableColors;

        if (colors == null) {
            colors = [];
        }

        if (colors.length == 0) {
            colors.push("gold");
        }

        return colors;
    }

    private createTableColors(colors: Array<string>): void {
        DataManager.TableColors = {};
        const themesConfig = Configuration.Configurations["Themes"];
        if (themesConfig != null) {
            const themeColors = ArrayUtils.stringArray(themesConfig.getAttribute("Colors"));
            const shapeColors = ArrayUtils.stringArray(themesConfig.getAttribute("ShapeColors"));
            const tintColors = ArrayUtils.stringArray(themesConfig.getAttribute("TintColors"));

            if (themeColors.length == shapeColors.length && themeColors.length == tintColors.length) {
                for (let i = 0; i < colors.length; i++) {
                    const colorIndex = themeColors.indexOf(colors[i]);

                    if (colorIndex > -1) {
                        DataManager.TableColors[colors[i]] = {
                            shapeColor: shapeColors[colorIndex],
                            tintColor: tintColors[colorIndex],
                        };
                    }
                }

                DataManager.TableColorsDefault = colors[0];
            }
        }
    }

    private createColorBtns(colors: Array<string>): void {
        for (let i = 0; i < colors.length; i++) {
            const btn = this.createButton(colors[i]);
            this.instance.appendChild(btn.instance);
        }
    }

    private createButton(color: string): HtmlButtonElement {
        const action = UserAction.ActionTableColor + color;
        const button = new HtmlButtonElement();
        const node = document.createElement("node");
        if (SchemasManager.CurrentPlayerSettings.theme == color) {
            DataManager.TableColor = color;
            node.setAttribute("CssClass", "settingBtn " + color + "Btn noHover _disabled");
        } else {
            node.setAttribute("CssClass", "settingBtn " + color + "Btn");
        }

        node.setAttribute("UIAction", action);
        node.setAttribute("UIActionDispatcher", action);
        button.create(node);

        button.instance.style.backgroundColor = "#" + DataManager.TableColors[color].tintColor;
        HtmlTableColorsElement.registerAction(action);

        return button;
    }

    private static registerAction(action: string): void {
        if (DataManager.TableColorsActions == null) {
            DataManager.TableColorsActions = [];
        }

        if (DataManager.TableColorsActions.indexOf(action) > -1) {
            return;
        }

        DataManager.TableColorsActions.push(action);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/HtmlTableColorsElement.ts
 **/